(function($) {
    var selector = ".scroll-section";

    var $slides = $(selector);

    var currentSlide = 0;
    var isAnimating = false;

    var stopAnimation = function() {
        setTimeout(function() {
            isAnimating = false;
        }, 300);
    };

    var bottomIsReached = function($elem) {
        var rect = $elem[0].getBoundingClientRect();
        return rect.bottom <= $(window).height();
    };

    var topIsReached = function($elem) {
        var rect = $elem[0].getBoundingClientRect();
        return rect.top >= 0;
    };

    document.addEventListener(
        "wheel",
        function(event) {
            var $currentSlide = $($slides[currentSlide]);

            if (isAnimating) {
                event.preventDefault();
                return;
            }

            var direction = -event.deltaY;

            if (direction < 0) {
                // next
                if (currentSlide + 1 >= $slides.length) return;
                if (!bottomIsReached($currentSlide)) return;
                event.preventDefault();
                currentSlide++;
                var $slide = $($slides[currentSlide]);
                var offsetTop = $slide.offset().top;
                isAnimating = true;
                $("html, body").animate({
                        scrollTop: offsetTop
                    },
                    700,
                    stopAnimation
                );
            } else {
                // back
                if (currentSlide - 1 < 0) return;
                if (!topIsReached($currentSlide)) return;
                event.preventDefault();
                currentSlide--;
                var $slide = $($slides[currentSlide]);
                var offsetTop = $slide.offset().top;
                isAnimating = true;
                $("html, body").animate({
                        scrollTop: offsetTop
                    },
                    700,
                    stopAnimation
                );
            }
        }, { passive: false }
    );
})(jQuery);


// slick slider
$(document).ready(function() {

    const slider = $('.slider');

    function onSliderAfterChange(event, slick, currentSlide) {
        $(event.target).data('current-slide', currentSlide);
    }

    function onSliderWheel(e) {
        var deltaY = e.originalEvent.deltaY,
            $currentSlider = $(e.currentTarget),
            currentSlickIndex = $currentSlider.data('current-slide') || 0;

        if (
            // check when you scroll up
            (deltaY < 0 && currentSlickIndex == 0) ||
            // check when you scroll down
            (deltaY > 0 && currentSlickIndex == $currentSlider.data('slider-length') - 1)
        ) {
            return;
        }

        e.preventDefault();

        if (e.originalEvent.deltaY < 0) {
            $currentSlider.slick('slickPrev');
        } else {
            $currentSlider.slick('slickNext');
        }
    }

    slider.each(function(index, element) {
            var $element = $(element);
            // set the length of children in each loop
            // but the better way for performance is to set this data attribute on the div.slider in the markup
            $element.data('slider-length', $element.children().length);
        })

        $('.slider').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            speed: 1000,
            cssEase: 'ease',
            fade: true,
            touchMove: true,
            touchThreshold: 50,
            responsive: [

                {
                    breakpoint: 1025,
                    settings: {
                     dots: true,
                     infinite: true   

                    }
                }

            ]

        })
        .on('afterChange', onSliderAfterChange)
        .on('wheel', onSliderWheel);

});